module.exports = "<div class=\"container\">\n  <div class=\"title\">{{abstract.title}}</div>\n  <div class=\"author\">{{abstract.author}}</div>\n  <div class=\"affiliation\">{{abstract.affiliation}}</div>\n  <div class=\"abstract\" [innerHTML]=\"abstract.abstract\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/abstracts/abstract/abstract.component.html
// module id = ../../../../../src/app/abstracts/abstract/abstract.component.html
// module chunks = main